import { EnumModel, EnumRecord } from "core/models/enum.model";
import { createOptionsFromRecord } from "core/utils/options.utils";

export interface ShipmentMethodEnumModel extends EnumModel {
  value: number;
}

export enum ShipmentMethodEnum {
  Post = 0,
  Immidiate = 1,
}

export const ShipmentMethod: EnumRecord<
  ShipmentMethodEnum,
  ShipmentMethodEnumModel
> = {
  [ShipmentMethodEnum.Post]: { value: 0, description: "پست" },
  [ShipmentMethodEnum.Immidiate]: { value: 1, description: "فوری" },
};

export const shipmentMethodData = createOptionsFromRecord(ShipmentMethod);
